import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { JobGradeAudit } from '../../+models/company-profile-audit.model';

@Component({
  selector: 'sd-portal-job-grade-audit-list',
  templateUrl: './job-grade-audit-list.component.html',
  styleUrls: ['./job-grade-audit-list.component.scss']
})
export class JobGradeAuditListComponent implements OnInit {
  @Input() jobGradeId: number;
  @Input() loading: boolean;
  @Input() jobGradeAudits: JobGradeAudit[];

  @Output() loadJobGrade = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadJobGrade.emit(this.jobGradeId);
  }

  onNextPage() {
    this.nextPage.emit(this.jobGradeId);
  }
}
